var _excluded = ["animationDuration", "animationName", "children", "onClose", "show", "width"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Div } from '@kizi/core-components';
import React, { useEffect } from 'react';
import { IconV2 as Icon } from '../components/IconV2';

var useBodyScrollLock = function useBodyScrollLock(isLocked) {
  useEffect(function () {
    if (isLocked) {
      var scrollY = window.scrollY;
      var scrollX = window.scrollX;
      document.body.style.position = 'fixed';
      document.body.style.top = "-".concat(scrollY, "px");
      document.body.style.left = "-".concat(scrollX, "px");
      document.body.style.width = '100%';
      document.body.style.height = '100%';
      document.body.style.overflow = 'hidden';
      return function () {
        var body = document.body.style;
        body.position = '';
        body.top = '';
        body.left = '';
        body.width = '';
        body.height = '';
        body.overflow = '';
        window.scrollTo(scrollX, scrollY);
      };
    }

    return undefined;
  }, [isLocked]);
};

export var Layover = function Layover(_ref) {
  var _ref$animationDuratio = _ref.animationDuration,
      animationDuration = _ref$animationDuratio === void 0 ? 0.3 : _ref$animationDuratio,
      _ref$animationName = _ref.animationName,
      animationName = _ref$animationName === void 0 ? 'ease' : _ref$animationName,
      children = _ref.children,
      onClose = _ref.onClose,
      show = _ref.show,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 410 : _ref$width,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var animation = "".concat(animationName, " ").concat(animationDuration, "s");
  useBodyScrollLock(show);
  var backgroundStyle = {
    opacity: 0,
    zIndex: -1
  };
  var wrapperStyle = {
    transform: '',
    zIndex: -1
  };
  wrapperStyle.transform = 'translateX(-100%)';

  if (show) {
    backgroundStyle = {
      opacity: 0.6,
      zIndex: 1
    };
    wrapperStyle = {
      transform: 'translateX(0%)',
      zIndex: 90
    };
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Div, {
    bg: "#000",
    height: "100vh",
    left: 0,
    onClick: onClose,
    position: "fixed",
    style: _objectSpread(_objectSpread({}, backgroundStyle), {}, {
      transition: "all ".concat(animation, " 0.15s")
    }),
    top: 0,
    width: "100vw",
    overflow: "hidden"
  }), /*#__PURE__*/React.createElement(Div, _extends({
    display: "flex",
    flexDirection: "column",
    left: 0,
    height: "100vh",
    position: "fixed",
    top: 0,
    style: _objectSpread(_objectSpread({}, wrapperStyle), {}, {
      transition: "all ".concat(animation)
    })
  }, restProps, {
    bg: "white",
    width: width,
    maxWidth: "100vw"
  }), /*#__PURE__*/React.createElement(Div, {
    ml: "auto",
    width: "auto",
    flexShrink: 0
  }, /*#__PURE__*/React.createElement(Icon, {
    display: "flex",
    fill: "second.0",
    height: 24,
    mr: 3,
    mt: 3,
    name: "cancel",
    onClick: onClose,
    style: {
      cursor: 'pointer'
    },
    width: 24
  })), /*#__PURE__*/React.createElement(Div, {
    height: "100%",
    overflowY: "auto",
    p: 6,
    width: "auto",
    flexGrow: 1,
    minHeight: 0
  }, children)));
};